// extracted by mini-css-extract-plugin
module.exports = {"inputMerchantStoreId":"add-merchant-id_inputMerchantStoreId__2YBgs"};